import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';

export interface IPromoModalProps {
  title: string;
  open: boolean;
  onClose(): void;
}

export function PromoModalWrapper({ title, open, onClose, children }: React.PropsWithChildren<IPromoModalProps>) {
  return <ModalWindow title={title} content={children} open={open} onClose={onClose} />;
}
